import { NewsCategory } from '@pt/models';

export function getCategoriesMock(count = 12): NewsCategory[] {
  const categories: NewsCategory[] = [];

  categories.push({
    id: null,
    slug: 'all',
    name: 'All',
    iconName: 'gift',
    isDeletable: true,
    visible: true,
  });

  for (let i = 1; i <= count; i++) {
    categories.push({
      id: i,
      slug: `category-${i}`,
      name: `Category ${i}`,
      iconName: 'gift',
      isDeletable: true,
      visible: true,
    });
  }

  return categories;
}
